export const API_PROXY = "https://millsonic.com/api/";

export const API_SONICOLA_URL = "https://apissl.millsonic.com/sonicola/v1/";

export const API_BACKEND_URL = "https://apissl.millsonic.com/backend/v1/";

export const EVENTS_ENDPOINT_URL =
  process.env.REACT_APP_EVENTS_ENDPOINT_URL || "/events";
